import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaArrowRight, FaEnvelope } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { requestOtpApi } from "../api/api";
import "../styles/Login.css";
import logo from "../resources/qr-icon-white.png";
import mindscraftLogo from "../resources/midscraftlogo.png";

const Login = () => {
  const navigate = useNavigate();
  const [apiError, setApiError] = useState("");

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Enter a valid enterprise email")
      .required("Enterprise email is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    setApiError("");
    try {
      const email = values.email.trim().toLowerCase();
      const response = await requestOtpApi(email);
      console.log("requestOtpApi response:", response);

      if (!response?.isSuccess) {
        setApiError(response?.message || "Unable to request OTP. Please try again.");
        return;
      }

      sessionStorage.setItem("pendingLoginEmail", email);
      navigate("/verify-account");
    } catch (error) {
      setApiError(error?.response?.data?.message || "Unable to request OTP. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <header className="login-brandtop">QRiva</header>

      <section className="login-leftpanel">
        <div className="login-emblem-wrap">
          <div className="login-emblem-frame">
            <img src={logo} alt="QRiva" className="login-emblem" />
          </div>
        </div>
        <h1 className="login-lefttitle">QRiva</h1>
        <p className="login-leftsubtitle">
          Real-time transaction infrastructure for the world's leading financial institutions.
        </p>
      </section>

      <section className="login-rightpanel">
        <div className="login-card">
          <h2 className="login-cardtitle">Welcome back</h2>
          <p className="login-cardsub">Enter your email to access the command center</p>

        <Formik
          initialValues={{ email: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="login-form">
              <div className="form-group">
                <label>Enterprise Email</label>
                <div className="input-wrapper">
                  <span className="input-icon">
                    <FaEnvelope />
                  </span>
                  <Field
                    type="email"
                    name="email"
                    placeholder="name@company.com"
                  />
                </div>
                <ErrorMessage
                  name="email"
                  component="div"
                  className="error"
                />
              </div>

              {apiError ? <div className="error">{apiError}</div> : null}

              <button
                type="submit"
                disabled={isSubmitting}
                className="btn-login"
              >
                {isSubmitting ? "Please wait..." : "Continue to Login"}
                <FaArrowRight />
              </button>

              <div className="login-security">Secured by <span>QRiva Shield</span></div>
            </Form>
          )}
        </Formik>
        </div>

        <footer className="login-footerlinks">
          <button type="button">Privacy Policy</button>
          <button type="button">Security Center</button>
          <button type="button">Contact Support</button>
        </footer>

        <div className="login-mindscraft">
          <img src={mindscraftLogo} alt="Mindscraft" className="login-mindscraft__logo" />
          <span>A product by <strong>Mindscraft</strong></span>
        </div>
      </section>
      </div>
  );
};

export default Login;
